module.exports = __webpack_public_path__ + "img/InterviewManagement.068d3dd5.png";